export const data = [
    {
        value:10,
        bizName:"Manufacturer"   
    },
    {
        value:20,
        bizName:"Exporter"   
    },
    {
        value:30,
        bizName:"Wholesaler"   
    },
    {
        value:37,
        bizName:"Distributor / Channel Partner"   
    },
    {
        value:40,
        bizName:"Retailer"   
    },
    {
        value:50,
        bizName:"Service Provider"   
    },
    {
        value:200,
        bizName:"Other"
    }
];
